<template>
  <section class="password__steps__layout">
    <section class="step__contain">
      <div class="step" :class="stepStatus[0]">
        {{ stepStatus[0] === "finished" ? "✓" : 1 }}
      </div>

      <small class="step__name" :class="stepStatus[0]">EMAIL</small>
    </section>

    <div class="step__divider" :class="stepStatus[0]" />

    <section class="step__contain">
      <div class="step" :class="stepStatus[1]">
        {{ stepStatus[1] === "finished" ? "✓" : 2 }}
      </div>

      <small class="step__name" :class="stepStatus[1]">CÓDIGO</small>
    </section>

    <div class="step__divider" :class="stepStatus[1]" />

    <section class="step__contain">
      <div class="step" :class="stepStatus[2]">
        {{ stepStatus[2] === "finished" ? "✓" : 3 }}
      </div>

      <small class="step__name" :class="stepStatus[2]">SENHA</small>
    </section>
  </section>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "PasswordStepsComponent",

  computed: {
    ...mapGetters({
      storeResource: "getPasswordStep",
    }),

    stepStatus() {
      switch (this.storeResource) {
        case "Email":
          return ["current", "", ""];

        case "Token":
          return ["finished", "current", ""];

        case "Passwords":
          return ["finished", "finished", "current"];

        case "Finish":
          return ["finished", "finished", "finished"];

        default:
          return ["current", "", ""];
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.password__steps__layout {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;

  .step__contain {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 5px;

    .step {
      display: flex;
      align-items: center;
      justify-content: center;

      width: 20px;
      height: 20px;
      background: #f1f1f1;
      border-radius: 20px;

      font-size: 12px;
    }

    .step__name {
      font-size: 10px;
    }
  }

  .step__divider {
    height: 2px;
    width: 75px;
    background: #f5f5f5;
    border-radius: 25px;
  }

  .step__divider.finished {
    background: #07912a2a;
  }

  .step.current {
    color: #1876d2;
    border: 2px solid #1876d2;
    background: #ffffff;
    font-weight: 600;
  }

  .step__name.current {
    font-weight: 600;
    color: #1876d2;
  }

  .step.finished {
    background: #049c2a;
    color: #ffffff;
  }

  .step__name.finished {
    font-weight: 600;
    color: #049c2a;
  }
}
</style>
